import {
  useGetReferralRules,
  useGetReferralTypeById,
} from '@xhype/card-app-sdk';
import { useGetUserData } from '@package/smart-wallet/hooks';

export const useGetReferralRulesForUser = () => {
  const { userInfo, isLoading: isLoadingUser } = useGetUserData();

  // Get user's referral type ID and business ID
  const referralTypeId = (userInfo as any)?.referralTypeId;
  const businessId = (userInfo as any)?.businessId;

  // Get referral type information
  const {
    data: referralType,
    isLoading: isLoadingReferralType,
    isError: isErrorReferralType,
    error: errorReferralType,
  } = useGetReferralTypeById({
    enabled: !!referralTypeId,
    referralTypeId: referralTypeId ?? 0,
  });

  // Get all referral rules for this referral type
  const {
    data: referralRulesData,
    isLoading: isLoadingRules,
    isError: isErrorRules,
    error: errorRules,
  } = useGetReferralRules({
    enabled: !!referralTypeId,
    referralId: referralTypeId ?? 0,
  });

  // TODO: Get business tiers when SDK is ready
  // For now, we'll show all rules from the referral type
  const businessTiers = (userInfo as any)?.business?.tiers || [];
  const businessTierIds = businessTiers.map(
    (tier: any) => tier.tierId || tier.id,
  );

  // Filter rules to only show those matching business tiers
  // If no business tiers, show all rules
  const filteredRules =
    businessTierIds.length > 0
      ? referralRulesData?.records?.filter((rule: any) =>
          businessTierIds.includes(rule.tierId),
        ) || []
      : referralRulesData?.records || [];

  return {
    isLoading: isLoadingUser || isLoadingReferralType || isLoadingRules,
    isError: isErrorReferralType || isErrorRules,
    error: errorReferralType || errorRules,
    referralType,
    rules: filteredRules,
    businessId,
  };
};
